import {styled} from '@mui/material/styles';
import {Skeleton} from '@atiautomacao/ati-ui-library';

export const StyledSkeleton = styled(Skeleton)`
  margin: 10px 0 10px 20px;
`;
export const StyledRootSkeleton = styled(Skeleton)`
  margin: 10px 0;
`;
